/**
 * Takip tarihli kur takip + para birimi başına TEKTİR; alacak formu (1. aşama / alacak ekranı) ile
 * alacak kalemi formu (3. aşama / kalem diyaloğu) aynı kuru iki ayrı listede gösterir. Listelerin
 * birbirine yazdığı yerler burada toplanır.
 */

/**
 * Kur kutusu gerçekten doldurulmuş mu? Boş sayılanlar: null, undefined, '', NaN ve <= 0.
 * Ondalık virgüllü metin ("49,0490") de sayılır: Number("49,0490") NaN verip dolu kuru boş sayardı.
 * Kur kutusu boşken Number('') = 0 yayar. Boş satırı API'ye yollamak kayıtlı kuru siler.
 */
export function kurTutariDolu(kur: any): boolean {
    return Number(String(kur?.tutar ?? "").replace(",", ".")) > 0;
}

/**
 * Kalemin kaydedilen kurunu alacağın listesindeki AYNI para birimi satırına yerinde yazar.
 * Alacak formu eski değeri gösterip Kaydet'inde DB'ye geri yazmasın diye kalem kaydından sonra çağrılır;
 * kalem formları bunu yalnız kullanıcı kur kutusunu değiştirdiyse çağırır (kurElleDegisti).
 *
 * Yeni satır eklenmez (alacakta o para biriminin satırı yoksa dokunulmaz); kalemin kuru boşsa
 * ve iki liste aynı diziyse (zaten aynı nesneler) hiçbir şey yapılmaz.
 */
export function alacakKurunuEsitle(alacakKurlari: any, kalemKurlari: any, paraBirimiId: any): void {
    if (!paraBirimiId || !Array.isArray(alacakKurlari) || !Array.isArray(kalemKurlari) || alacakKurlari === kalemKurlari) {
        return;
    }
    // id'ler API'den number, formdan string gelebilir: == bilinçli
    const kalemKuru = kalemKurlari.find((kur: any) => kur.para_birimi_id == paraBirimiId);
    const alacakKuru = alacakKurlari.find((kur: any) => kur.para_birimi_id == paraBirimiId);
    if (alacakKuru && kurTutariDolu(kalemKuru)) {
        alacakKuru.tutar = kalemKuru.tutar;
    }
}
